module.exports = __webpack_public_path__ + "static/media/icon-calendar.11d13b0a.svg";